module.exports = __webpack_public_path__ + "img/icon-share.6a3b7f3b.png";